/* eslint-disable no-nested-ternary */
import classNames from "classnames";
import Skeleton from "react-loading-skeleton";

// Hooks
import { useBreakpoint } from "hooks/useBreakpoint";

import "./styles.sass";

type SkeletonHeaderProps = {
  isAuthenticated: boolean | null;
};

const SkeletonHeader = (props: SkeletonHeaderProps) => {
  const { isAuthenticated } = props;

  const { isDesktop } = useBreakpoint();

  const logoHeight = isDesktop ? 42 : 36;

  const balanceHeight = isDesktop ? 52 : 36;

  const btnSize = isDesktop ? 52 : 28;

  const topClass = classNames("SkeletonHeader__top", {
    auth: isAuthenticated,
  });

  return (
    <div className="SkeletonHeader">
      <div className={topClass}>
        <div className="SkeletonHeader__logo">
          <Skeleton height={logoHeight} width={84} />
        </div>
        <div className="SkeletonHeader__navigation">
          <Skeleton
            className="SkeletonHeader__navigation_item"
            height={14}
            width={60}
            count={5}
            inline
          />
        </div>
        {!isAuthenticated && (
          <div className="SkeletonHeader__userinfo">
            <Skeleton height={52} width={165} />
          </div>
        )}
        {isAuthenticated && (
          <div className="SkeletonHeader__balance">
            <Skeleton height={balanceHeight} width={134} />
          </div>
        )}
        {!isAuthenticated && isDesktop && (
          <div className="SkeletonHeader__controls">
            <Skeleton width={146} height={52} inline count={2} />
          </div>
        )}
        <div className="SkeletonHeader__buttons">
          <Skeleton
            className="SkeletonHeader__button"
            height={btnSize}
            width={btnSize}
            // eslint-disable-next-line no-nested-ternary
            count={!isDesktop ? 2 : isAuthenticated ? 2 : 1}
            inline
          />
        </div>
      </div>

      {isDesktop ? null : isAuthenticated ? null : (
        <div className="SkeletonHeader__controls">
          <Skeleton width="50%" height={52} inline count={2} />
        </div>
      )}
    </div>
  );
};

export default SkeletonHeader;
